import { InlineRowActionsWebComponent } from './component/InlineRowActionsWebComponent';
import { WEB_COMPONENT_INLINE_ROW_ACTIONS } from '../../../webcomponents.constants';

export { InlineRowActionsWebComponent };

window.customElements.define(WEB_COMPONENT_INLINE_ROW_ACTIONS, InlineRowActionsWebComponent);
